import React, { useState } from 'react'
import {
  Button,
  Input,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Row,
  Col,
  Switch,
  Select,
  Checkbox
} from 'antd'
// import IntlMessages from '../util/IntlMessages'
import ds from '../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch } from 'react-redux'
import { loadData } from '../appRedux/actions/Setting'
import { userLogOut } from '../appRedux/actions/Auth'
import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import { notAllowMsgCheck } from '../appRedux/actions'
import {
  PRINTING_TYPE,
  PrintCheckDatetime,
  PrintCheckOutlet,
  PrintCheckRegister,
  PrintCheckServedBy
} from '../constants/StoreSetting'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const CheckboxGroup = Checkbox.Group
const plainOptions = [
  PrintCheckServedBy,
  PrintCheckDatetime,
  PrintCheckOutlet,
  PrintCheckRegister
]
const defaultCheckedList = plainOptions

const AddPrinters = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const [visible, setVisible] = React.useState(false)
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [getIsShow, setIsShow] = React.useState(false)
  const [isSpinningLoading, setSpinningLoading] = React.useState(false)
  const [selType, setSelType] = React.useState(2)
  const [isActive, setIsActive] = React.useState(false)
  const [checkedList, setCheckedList] = React.useState(defaultCheckedList)

  React.useEffect(() => {
    //getListingTableData();
  }, [])

  const handleOk = () => {
    setConfirmLoading(true)
    setTimeout(() => {
      setVisible(false)
      setConfirmLoading(false)
    }, 2000)
  }

  const handleCancel = () => {
    //;
    //props['IsShow'] = false;
    setVisible(false)
  }

  const onFinishFailed = errorInfo => {
    message.error('Failed')
  }

  const onChange = list => {
    setCheckedList(list)
  }

  const onFinish = async values => {
    setVisible(false)
    setIsShow(true)
    if (values && values.PrintName) {
      await ds
        .postPrintersService(
          {
            // PrinterID: values.PrintName,
            Name: values.PrintName,
            IP: values.IP,
            Port: values.PORT,
            IsActive: isActive ? true : false,
            Type: selType,
            Header: values.header ? values.header : '',
            Subtitle1: values.subtitle1 ? values.subtitle1 : '',
            Subtitle2: values.subtitle2 ? values.subtitle2 : '',
            ShowOutlet:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckOutlet).length > 0
                ? true
                : false,
            ShowRegister:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckRegister).length > 0
                ? true
                : false,
            ShowDatetime:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckDatetime).length > 0
                ? true
                : false,
            ShowServedBy:
              checkedList &&
              checkedList.length > 0 &&
              checkedList.filter(a => a == PrintCheckServedBy).length > 0
                ? true
                : false,
            Footer: values.footer ? values.footer : ''
          },
          BEHAVIOUR_TYPE.POST
        )
        .then(response => {
          if (response) {
            form.resetFields()
            setCheckedList(defaultCheckedList)
            dispatch(loadData(true))
            message.success('Successfully Added')
          } else message.error('Check conection & Try Again')
          setIsShow(false)
        })
        .catch(e => {
          message.error('Something went wrong')
          setIsShow(false)
          notAllowMsgCheck(e)
        })
    } else message.error('Kindly provide proper information')
  }

  const showModal = () => {
    //
    //props['isRecuring'] = true;
    //form.setFieldsValue({ PrintName: asd});
    setVisible(true)
  }

  function setTypeCheck (e) {
    if (e) {
      setSelType(e)
    }
  }

  return (
    <div>
      {getIsShow ? (
        <div style={{ marginRight: '660px' }}>
          <Spin tip={'Loading'} spinning={getIsShow} size='large'></Spin>
        </div>
      ) : (
        <div>
          <Button
            className='dk-btn-add orange-btn-div'
            type='primary'
            onClick={showModal}
            size='large'
          >
            Add Printer
          </Button>
          <Modal
            title={'New Printer'}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            centered={true}
            width={'402px'}
            footer={null}
          >
            <Form
              {...formItemLayout}
              form={form}
              name='brands'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                prefix: '86'
              }}
              scrollToFirstError
            >
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='PrintName'
                label={
                  <span>
                    <strong>Printer Name</strong>
                    <Tooltip title='Name'></Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: 'Please enter Printer name',
                    whitespace: true
                  }
                ]}
              >
                <Input placeholder='Printer Name' />
              </Form.Item>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                // name='Type'
                label={
                  <span>
                    <strong>Type</strong>
                    <Tooltip title='Type'></Tooltip>
                  </span>
                }
                // rules={[
                //   {
                //     required: true,
                //     message: 'Please select Printer type',
                //     whitespace: true
                //   }
                // ]}
              >
                <Select
                  size='large'
                  onChange={e => setTypeCheck(e)}
                  value={selType}
                >
                  {PRINTING_TYPE.map((e, key) => {
                    return (
                      <Select.Option
                        key={key}
                        value={e.id}
                        disabled={e.id == 1}
                      >
                        {e.name}
                      </Select.Option>
                    )
                  })}
                </Select>{' '}
              </Form.Item>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='header'
                label={
                  <span>
                    <strong>Title</strong>
                    <Tooltip title='Title to print'></Tooltip>
                  </span>
                }
                // rules={[
                //   {
                //     required: true,
                //     message: 'Please enter Printer name',
                //     whitespace: true
                //   }
                // ]}
              >
                <Input placeholder='Print Title' />
              </Form.Item>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='subtitle1'
                label={
                  <span>
                    <strong>Subtitle 1</strong>
                    <Tooltip title='Subtitle 1 to print'></Tooltip>
                  </span>
                }
                // rules={[
                //   {
                //     required: true,
                //     message: 'Please enter Printer name',
                //     whitespace: true
                //   }
                // ]}
              >
                <Input placeholder='Subtitle 1' />
              </Form.Item>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='subtitle2'
                label={
                  <span>
                    <strong>Subtitle 2</strong>
                    <Tooltip title='Subtitle 2 to print'></Tooltip>
                  </span>
                }
                // rules={[
                //   {
                //     required: true,
                //     message: 'Please enter Printer name',
                //     whitespace: true
                //   }
                // ]}
              >
                <Input placeholder='Subtitle 2' />
              </Form.Item>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                name='footer'
                label={
                  <span>
                    <strong>Footer</strong>
                    <Tooltip title='Footer to print'></Tooltip>
                  </span>
                }
                // rules={[
                //   {
                //     required: true,
                //     message: 'Please enter Printer name',
                //     whitespace: true
                //   }
                // ]}
              >
                <Input placeholder='Printer Footer' />
              </Form.Item>
              {selType && selType == 2 && (
                <>
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right'
                    name='IP'
                    label={
                      <span>
                        <strong>IP</strong>
                        <Tooltip title='IP'></Tooltip>
                      </span>
                    }
                  >
                    <Input placeholder='IP' />
                  </Form.Item>
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right'
                    name='PORT'
                    label={
                      <span>
                        <strong>PORT</strong>
                        <Tooltip title='PORT'></Tooltip>
                      </span>
                    }
                  >
                    <Input placeholder='PORT' />
                  </Form.Item>
                </>
              )}
              <Form.Item className='ant-form-item-label-custom ant-form-margin-right mt-12'>
                <CheckboxGroup
                  options={plainOptions}
                  value={checkedList}
                  onChange={onChange}
                />
              </Form.Item>
              <Form.Item
                className='ant-form-item-label-custom ant-form-margin-right'
                // name='ACTIVE'
                label={
                  <span>
                    <strong>Is Active</strong>
                    <Tooltip title='Is Active'></Tooltip>
                  </span>
                }
              >
                <span>
                  <a className='gx-link'>
                    <Switch
                      checked={isActive}
                      onChange={ev => {
                        setIsActive(ev)
                      }}
                    />
                  </a>
                </span>
              </Form.Item>
              <Row style={{ marginRight: 0 }} justify='end'>
                <Col>
                  <Button
                    className='dk-btn-add'
                    type='primary'
                    block
                    htmlType='submit'
                  >
                    Add
                  </Button>
                </Col>
              </Row>
            </Form>
          </Modal>
        </div>
      )}
    </div>
  )
}

export default AddPrinters
